/**
 * @generated SignedSource<<79d26a4054919d430d57df39fb195ed0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceIndicator_space$data = {
  readonly color: {
    readonly dark: string;
    readonly light: string;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "SpaceIndicator_space";
};
export type SpaceIndicator_space$key = {
  readonly " $data"?: SpaceIndicator_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpaceIndicator_space",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Color",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "light",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dark",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};

(node as any).hash = "e1aaffdd5e54e034bac8ebc83871d74d";

export default node;
